import slider from '../helpers/slider';

interface IConfig {
  slider: string,
  featuredImg: string,
  item: string,
  className: IClassName
}

interface IClassName {
  selected: string
}
class Gallery {

  private config:IConfig;

  constructor() {
    this.config = {
      slider: '[data-gallery-slider]',
      featuredImg: '[data-gallery-featured-img]',
      item: '[data-gallery-item]',
      className: {
        selected: 'gallery__slider-item--selected'
      }
    }
  }

  init() {
    const nodeList:NodeList = document.querySelectorAll(this.config.slider);
    nodeList.forEach((node:HTMLElement) => {
      const currentSlider = slider.init(node, { items: 4.5 })
      const currentSliderInfo = currentSlider.getInfo();
      const items = currentSliderInfo.container.querySelectorAll(this.config.item);
      currentSlider.events.on('transitionEnd', this.handleTransitionEnd.bind(this));
      currentSliderInfo.container.querySelector('.tns-slide-active').classList.add(this.config.className.selected);
      items.forEach((item, index) => item.addEventListener('click', this.handleClick.bind(this)));
    });
  }

  update() {
    const featuredImg:HTMLImageElement = document.querySelector(this.config.featuredImg + ' img');
    const activeItem:HTMLImageElement = document.querySelector('.' + this.config.className.selected + ' img');
    featuredImg.src = activeItem.src;
  }

  handleTransitionEnd() {
    this.update();
  }

  handleClick(event:any) {
    const { parentNode }:{ parentNode: HTMLElement } = event.target;
    if (parentNode.dataset.galleryItem) {
      document.querySelectorAll(this.config.item).forEach(item => item.classList.remove(this.config.className.selected));
      parentNode.classList.add(this.config.className.selected);
      this.update();
    }
  }

}

export default new Gallery();